import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppTokenHandler } from 'src/app/Global-Services/app-token-handler';
import { CommonService } from 'src/app/Global-Services/common.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css'],
  standalone: false,
})
export class ErrorComponent implements OnInit {
  ErrorMessage: any;
  constructor(public route: ActivatedRoute, private gservice: CommonService,private tokenHandler: AppTokenHandler,) { }

  ngOnInit() {
    this.ErrorMessage = this.GetErrorMessageOnIDBehalf(this.route.snapshot.paramMap.get('id'));
    sessionStorage.removeItem('userToken');
    this.tokenHandler.clearSessionToken();
    sessionStorage.removeItem('userDetails');
    this.tokenHandler.clearAllAzureCookie();
  }
  GetErrorMessageOnIDBehalf(Id: any): any {
    // tslint:disable-next-line:max-line-length
    let ErrorMsg = 'During the processing of the last request an error occurred. Please try again or contact the system administrator if you continue to experience problems.';
   if (Id === '1') {
    ErrorMsg = 'You are not Authorized to view this Application';
   }
   if (Id === '2') {
    // tslint:disable-next-line:max-line-length
    ErrorMsg = 'During the processing of the last request an error occurred. Please try again or contact the system administrator if you continue to experience problems.';
   }
   if (Id === '3') {
    // tslint:disable-next-line:max-line-length
    ErrorMsg = 'Session Expired, Please login again';
   }
   if (Id === '4') {
    // tslint:disable-next-line:max-line-length
    ErrorMsg = 'You are not Authorized to view this Page';
   }
   if (Id === '5') {
    // tslint:disable-next-line:max-line-length
    ErrorMsg = 'Page you are looking for does not exist or been removed.Please contact the system administrator';
   }
    return ErrorMsg;
  }
  Login() {
    this.gservice.Login();
}
}
